module.exports = __webpack_public_path__ + "img/order-tacker.2e039722.png";